module.exports = __webpack_public_path__ + "static/media/rom3.74405afe.jpg";